import { c as _c } from "react-compiler-runtime";
import { useResizeObserver } from "@react-aria/utils";
import * as React from "react";
import { Autocomplete, Label, Tag as AriaTag, TagGroup as AriaTagGroup, TagList } from "react-aria-components";
import { Plus } from "../icons/solid.js";
import { Badge } from "./Badge.js";
import { BadgeContext } from "./BadgeContext.js";
import { addOptionContainer, badgeContainer, categoryContainer, groupHeader, optionGroupContainer, optionListContainer, optionListItemsContainer, optionListSingleLineHeight, popoverWidth, popoverWrapper } from "./BadgeGroup.css.js";
import { Button } from "./Button.js";
import { ListBox } from "./ListBox.js";
import { Popover } from "./Popover.js";
import { SearchInput } from "./SearchInput.js";
import { ListBoxItem } from "./shared/DropdownItem.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AddBadgeToGroup = t0 => {
  const $ = _c(24);
  const {
    badgeGroupId,
    badgeGroupOptions,
    onAddOption,
    searchAriaLabel,
    isOpen,
    onOpenChange,
    triggerRef
  } = t0;
  const [searchTerm, setSearchTerm] = React.useState("");
  let t1;
  if ($[0] !== searchTerm) {
    t1 = options => {
      if (searchTerm.length === 0) {
        return options;
      }
      const lowerCaseSearchTerm = searchTerm.toLocaleLowerCase();
      return options.filter(o => o.name.toLocaleLowerCase().includes(lowerCaseSearchTerm));
    };
    $[0] = searchTerm;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const filteredTagOptions = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = input => {
      setSearchTerm(input ?? "");
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== searchAriaLabel || $[4] !== searchTerm) {
    t3 = /*#__PURE__*/_jsx(SearchInput, {
      ariaLabel: searchAriaLabel,
      search: searchTerm,
      onSearch: t2
    });
    $[3] = searchAriaLabel;
    $[4] = searchTerm;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== badgeGroupId || $[7] !== badgeGroupOptions || $[8] !== filteredTagOptions || $[9] !== onAddOption) {
    let t5;
    if ($[11] !== badgeGroupId || $[12] !== onAddOption) {
      t5 = option => /*#__PURE__*/_jsx(ListBoxItem, {
        onAction: () => {
          onAddOption(badgeGroupId, option.id);
        },
        isDisabled: option.isSelected,
        children: option.name
      }, option.id);
      $[11] = badgeGroupId;
      $[12] = onAddOption;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    t4 = filteredTagOptions(badgeGroupOptions).map(t5);
    $[6] = badgeGroupId;
    $[7] = badgeGroupOptions;
    $[8] = filteredTagOptions;
    $[9] = onAddOption;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = /*#__PURE__*/_jsx(ListBox, {
      size: "m",
      escapeKeyBehavior: "none",
      children: t4
    });
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t5) {
    t6 = /*#__PURE__*/_jsx(Autocomplete, {
      children: /*#__PURE__*/_jsxs("div", {
        role: "presentation",
        className: popoverWrapper,
        children: [t3, t5]
      })
    });
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== isOpen || $[20] !== onOpenChange || $[21] !== t6 || $[22] !== triggerRef) {
    t7 = /*#__PURE__*/_jsx(Popover, {
      width: popoverWidth,
      placement: "bottom",
      isOpen: isOpen,
      onOpenChange: onOpenChange,
      triggerRef: triggerRef,
      children: t6
    });
    $[19] = isOpen;
    $[20] = onOpenChange;
    $[21] = t6;
    $[22] = triggerRef;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};
export const BadgeGroup = t0 => {
  const $ = _c(65);
  const {
    groupId,
    groupName,
    options,
    onAddOption,
    onDeleteOption,
    searchAriaLabel,
    color: t1,
    interactive,
    badgeBorders: t2
  } = t0;
  const color = t1 === undefined ? "white" : t1;
  const badgeBorders = t2 === undefined ? false : t2;
  const [isAddingNewOption, setIsAddingNewOption] = React.useState(false);
  const [isMultiLine, setIsMultiLine] = React.useState(false);
  const triggerRef = React.useRef(null);
  const containerRef = React.useRef(null);
  const optionListRef = React.useRef(null);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const optionList = optionListRef.current;
      if (!optionList) {
        return;
      }
      const isWrapping = optionList.offsetHeight > optionListSingleLineHeight;
      setIsMultiLine(isWrapping);
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const onResize = t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      ref: optionListRef,
      onResize
    };
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  useResizeObserver(t4);
  let T0;
  let T1;
  let T2;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== badgeBorders || $[3] !== color || $[4] !== groupName || $[5] !== interactive || $[6] !== isMultiLine || $[7] !== onDeleteOption || $[8] !== options) {
    const displayOptions = options.filter(_temp);
    let t15;
    if ($[22] !== badgeBorders) {
      t15 = {
        inGroup: true,
        badgeBorders
      };
      $[22] = badgeBorders;
      $[23] = t15;
    } else {
      t15 = $[23];
    }
    const badgeContextValue = t15;
    T2 = BadgeContext.Provider;
    t14 = badgeContextValue;
    if ($[24] !== color || $[25] !== isMultiLine) {
      t12 = categoryContainer({
        multiLine: isMultiLine,
        color
      });
      $[24] = color;
      $[25] = isMultiLine;
      $[26] = t12;
    } else {
      t12 = $[26];
    }
    t13 = containerRef;
    T1 = AriaTagGroup;
    t9 = "single";
    t10 = optionGroupContainer;
    if ($[27] !== groupName) {
      t11 = /*#__PURE__*/_jsx(Label, {
        className: groupHeader,
        children: groupName
      });
      $[27] = groupName;
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    t8 = optionListContainer;
    T0 = TagList;
    t5 = optionListItemsContainer;
    t6 = optionListRef;
    let t16;
    if ($[29] !== interactive || $[30] !== onDeleteOption) {
      t16 = option => {
        const baseBadgeProps = {
          size: "s",
          color: option.badgeColor ?? "gray"
        };
        return /*#__PURE__*/_jsx(AriaTag, {
          textValue: option.name,
          className: badgeContainer,
          children: interactive ? /*#__PURE__*/_jsx(Badge, {
            variant: "close",
            onClose: () => {
              onDeleteOption(option.id);
            },
            ...baseBadgeProps,
            children: option.name
          }) : /*#__PURE__*/_jsx(Badge, {
            variant: "default",
            leadingIcon: option.badgeLeadingIcon,
            ...baseBadgeProps,
            children: option.name
          })
        }, option.id);
      };
      $[29] = interactive;
      $[30] = onDeleteOption;
      $[31] = t16;
    } else {
      t16 = $[31];
    }
    t7 = displayOptions.map(t16);
    $[2] = badgeBorders;
    $[3] = color;
    $[4] = groupName;
    $[5] = interactive;
    $[6] = isMultiLine;
    $[7] = onDeleteOption;
    $[8] = options;
    $[9] = T0;
    $[10] = T1;
    $[11] = T2;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    T0 = $[9];
    T1 = $[10];
    T2 = $[11];
    t10 = $[12];
    t11 = $[13];
    t12 = $[14];
    t13 = $[15];
    t14 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t15;
  if ($[32] !== T0 || $[33] !== t5 || $[34] !== t6 || $[35] !== t7) {
    t15 = /*#__PURE__*/_jsx(T0, {
      className: t5,
      ref: t6,
      children: t7
    });
    $[32] = T0;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t15 || $[38] !== t8) {
    t16 = /*#__PURE__*/_jsx("div", {
      className: t8,
      children: t15
    });
    $[37] = t15;
    $[38] = t8;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== interactive) {
    t17 = interactive && /*#__PURE__*/_jsx("div", {
      ref: triggerRef,
      className: addOptionContainer,
      children: /*#__PURE__*/_jsx(Button, {
        variant: "iconOnly",
        leadingIcon: Plus,
        onPress: () => {
          setIsAddingNewOption(true);
        },
        hierarchy: "listAdd",
        size: "xs"
      })
    });
    $[40] = interactive;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== T1 || $[43] !== t10 || $[44] !== t11 || $[45] !== t16 || $[46] !== t17 || $[47] !== t9) {
    t18 = /*#__PURE__*/_jsxs(T1, {
      selectionMode: t9,
      className: t10,
      children: [t11, t16, t17]
    });
    $[42] = T1;
    $[43] = t10;
    $[44] = t11;
    $[45] = t16;
    $[46] = t17;
    $[47] = t9;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== groupId || $[50] !== interactive || $[51] !== isAddingNewOption || $[52] !== onAddOption || $[53] !== options || $[54] !== searchAriaLabel) {
    t19 = interactive && /*#__PURE__*/_jsx(AddBadgeToGroup, {
      badgeGroupId: groupId,
      badgeGroupOptions: options,
      onAddOption: onAddOption,
      searchAriaLabel: searchAriaLabel,
      isOpen: isAddingNewOption,
      onOpenChange: setIsAddingNewOption,
      triggerRef: triggerRef
    });
    $[49] = groupId;
    $[50] = interactive;
    $[51] = isAddingNewOption;
    $[52] = onAddOption;
    $[53] = options;
    $[54] = searchAriaLabel;
    $[55] = t19;
  } else {
    t19 = $[55];
  }
  let t20;
  if ($[56] !== t12 || $[57] !== t13 || $[58] !== t18 || $[59] !== t19) {
    t20 = /*#__PURE__*/_jsxs("div", {
      className: t12,
      ref: t13,
      children: [t18, t19]
    });
    $[56] = t12;
    $[57] = t13;
    $[58] = t18;
    $[59] = t19;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  let t21;
  if ($[61] !== T2 || $[62] !== t14 || $[63] !== t20) {
    t21 = /*#__PURE__*/_jsx(T2, {
      value: t14,
      children: t20
    });
    $[61] = T2;
    $[62] = t14;
    $[63] = t20;
    $[64] = t21;
  } else {
    t21 = $[64];
  }
  return t21;
};
function _temp(o) {
  return o.isSelected === true;
}
//# sourceMappingURL=BadgeGroup.js.map